
import Breadcrumbs from '~/components/moleculus/Breadcrumbs.vue'
import error from '~/layouts/error.vue'

export default {
  name: 'ContentPage',
  components: {
    Breadcrumbs,
    RPHAbout: () => import('rph/templates/RPHAbout/index.vue'),
    Heading: () => import('~/components/atoms/Heading.vue'),
  },
  async asyncData({ route, store }) {
    await Promise.all([
      store.dispatch('rph-content/getContents', { slug: route.params.slug }),
      store.dispatch('rph-menu/getMenu'),
    ])
  },
  head() {
    return {
      title: this.item?.attributes?.seo?.title || '',
      meta: this.$services.head.createMeta({
        title: this.item?.attributes?.seo?.title,
        description: this.item?.attributes?.seo?.description,
        keywords: this.item?.attributes?.seo?.keywords,
        ogImage: this.item?.image || '',
        index: this.isNoIndexPage,
      }),
      link: [this.$services.head.createCanonicalLink(this.$route.path)],
      script: [{ json: this.structuredData, type: 'application/ld+json' }],
    }
  },
  computed: {
    breadcrumbs() {
      return this.$services.breadcrumbs.createCrumbs([
        { title: this.item?.attributes?.title || 'Об Aurma.kz', slug: '' },
      ])
    },
    item() {
      return this.$store.getters['rph-content/content']
    },
    categories() {
      return this.$store.getters['rph-menu/menuAbout']
    },
    categoryActive() {
      const categoryList = []
      for (const key in this.categories) {
        categoryList.push(this.categories[key])
      }
      return categoryList.flat().find((item) => item.url === this.$route.path || '')
    },
    structuredData() {
      return {
        '@context': 'https://schema.org',
        '@type': 'Pharmacy',
        openingHours: 'пн-вс 10.00-19.00',
        brand: {
          '@type': 'Brand',
          name: 'Aurma.kz',
        },
        address: {
          '@type': 'PostalAddress',
          addressLocality: 'Алматы',
          addressCountry: 'Казахстан',
        },
        description: this.item?.attributes?.text.replace(/<\/?[^>]+(>|$)/g, ''),
      }
    },

    isNoIndexPage() {
      const noIndexPages = [
        '/content/apteki',
        '/content/kontakty',
        '/content/glavnaya',
        '/content/medtsentry',
        '/content/mnn',
      ]
      return !noIndexPages.includes(this.$route.path)
    },
  },

  created() {
    if (!this.item?.attributes) {
      this.$router.push({
        name: 'custom-error',
        params: { error: { statusCode: 404, message: 'Страница не найдена' } },
      })
    }
  },
}
